import React, { useState } from 'react';
import {
  Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper,
  TextareaAutosize, Box,
  CircularProgress
} from '@mui/material';
import GlobalButton from '../../../utils/GlobalButton';
import axiosInstance from '../../../utils/axiosInstance';
import { langTranslatePost, translator } from '../../shared/ApiEndpoint';
import { notification } from 'antd';
import { Button } from 'react-bootstrap';
import { PiTranslateBold } from "react-icons/pi";


const MAX_BUTTON_BYTES = 64;

const getByteLength = (text) => new TextEncoder().encode(text || "").length;

function StickyTable({ selectedLanguages, languagesList, botId, translations, setTranslations ,bots_type}) {
  const [translationLoading,setTranslationLoading]=useState({})
  const handleTranslationChange = (questionId, langId, indexOrValue, maybeValue) => {
  setTranslations(prev => {
    const prevLang = prev[langId] || {};
    const prevQ = prevLang[questionId] || { questions: '', options: [] };

    // If 3 arguments: changing question
    if (maybeValue === undefined) {
      return {
        ...prev,
        [langId]: {
          ...prevLang,
          [questionId]: {
            ...prevQ,
            questions: indexOrValue, // indexOrValue is actually the new value
          }
        }
      };
    }

    // If 4 arguments: changing option
    const index = indexOrValue;
    const value = maybeValue;

    const updatedOptions = [...(prevQ.options || [])];
    updatedOptions[index] = value;

    return {
      ...prev,
      [langId]: {
        ...prevLang,
        [questionId]: {
          ...prevQ,
          options: updatedOptions,
        }
      }
    };
  });
};


  



  // const handleSaveConfig = async () => {
  //   const payload = {
  //     bot_id: botId,
  //     config: {
  //       languages: translations
  //     },
  //     selectedLanguages:selectedLanguages,
  //     bots_type:bots_type
  //   };
  //   try {
  //     const res = await axiosInstance.post(langTranslatePost, payload, { withCredentials: true });
  //     if (res.status === 200) {
  //       console.log("Saved");
  //        notification.success({
  //         key: 'bot-config-save-success', 
  //         description: 'Bot config saved successfully!',
  //         placement: 'topRight',
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleSaveConfig = async () => {

      if (!isValidTranslations()) {
    notification.error({
      key: 'translation-too-long',
      description: `Some option text exceeds ${MAX_BUTTON_BYTES} bytes. Please shorten it before saving.`,
      placement: 'topRight',
    });
    return;
  }

  // ✅ If all valid — proceed
  const payload = {
    bot_id: botId,
    config: { languages: translations },
    selectedLanguages,
    bots_type,
  };

  try {
    const res = await axiosInstance.post(langTranslatePost, payload, { withCredentials: true });
    if (res.status === 200) {
      notification.success({
        key: 'bot-config-save-success',
        description: 'Bot config saved successfully!',
        placement: 'topRight',
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const isValidTranslations = () => {
  for (const langId of selectedLanguages) {
    const langData = translations?.[langId] || {};
    for (const qid in langData) {
      const q = langData[qid];

      // Check options byte length
      if (q.options?.some(opt => getByteLength(opt) > MAX_BUTTON_BYTES)) {
        return false;
      }
    }
  }
  return true;
};

  const handleTranslate=async(langCode,datas)=>{
    const payload ={
        target_lang:langCode,
        data:datas
    }
     setTranslationLoading((prev)=>({
            ...prev,
            [langCode]:true
        }))
    try {
        const resp= await axiosInstance.post(translator,payload,{withCredentials:true})
        if(resp.status===200){
              const translations = resp.data.translated;
              setTranslations(prev => ({
        ...prev,
        [langCode]: {
          ...prev[langCode],
          ...translations
        }
      }));
        }
    } catch (error) {
        console.log(error)
    }finally{
        setTranslationLoading((prev)=>({
            ...prev,
            [langCode]:false
        }))
    }
  }

  // Fallback for when English base is not available
  const englishBase = translations?.en || {};
  const questionIds = Object.keys(englishBase);

  console.log(englishBase)

  return (
    <>
      <Box display="flex" justifyContent="flex-end" mb={3}>
        <GlobalButton children={"Save"} size="sm" variant="contained" onClick={handleSaveConfig} />
      
      </Box>
      <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto', maxHeight: 400 }}>
        <Table stickyHeader sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  position: 'sticky',
                  left: 0,
                  backgroundColor: 'white',
                  zIndex: 3,
                  minWidth: 300,
                  fontWeight: 'bold'
                }}
              >
                Questions (English)
              </TableCell>
              {selectedLanguages.map(langId => {
                const langName = languagesList.find(lang => lang.code === langId)?.language || langId;
                return (
                  <TableCell key={langId} sx={{ fontWeight: 'bold', minWidth: 300 }}>
                   <Box display="flex" alignItems="center" justifyContent={'center'} gap={1}>
                    {langName}
<Button
  size="small"
  variant="secondary"
  onClick={() => handleTranslate(langId, translations?.["en"])}
  disabled={translationLoading?.[langId]}
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px', // optional to maintain button width
    height: '36px'     // ensure consistent button height
  }}
>
  {translationLoading?.[langId] ? (
    <CircularProgress size={18} color="inherit" />
  ) : (
    <PiTranslateBold size={22} />
  )}
</Button>


                 </Box>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {questionIds.map((qid) => (
              <TableRow key={qid}>
                {/* English question cell */}
                    <TableCell
        sx={{
          position: 'sticky',
          left: 0,
          backgroundColor: '#f9f9f9',
          zIndex: 1,
          minWidth: 300
        }}
      >
        {/* Question */}
        <div><strong>Q:</strong> {englishBase[qid].questions}</div>

        {/* Options */}
        <div><strong>Options:</strong>
        {englishBase[qid].options?.length > 0 ? (
          <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
            {englishBase[qid].options.map((opt, index) => (
              <li key={index}>{opt}</li>
            ))}
          </ul>
        ) : (
          <div style={{ fontStyle: 'italic', color: '#888' }}>No options</div>
        )}
        </div>
      </TableCell>

                {/* Translations input */}
                {selectedLanguages.map((langId) => (
<TableCell key={`${qid}-${langId}`} sx={{ minWidth: 300, position: 'relative' }}>
  {/* Translated question */}
  <TextareaAutosize
    minRows={4}
    maxRows={4}
    placeholder="Translate question..."
    value={translations?.[langId]?.[qid]?.questions || ''}
    onChange={(e) => handleTranslationChange(qid, langId, e.target.value)}
    style={{
      width: '100%',
      padding: '8px',
      fontSize: '1rem',
      lineHeight: '1.5',
      borderRadius: '4px',
      border: '1px solid #ccc',
      resize: 'none',
      marginBottom: '8px',
    }}
  />

  {/* Translated options */}
  {englishBase[qid].options?.map((_, index) => (
    <div>
    <input
      key={index}
      type="text"
      placeholder={`Translate option ${index + 1}`}
      value={translations?.[langId]?.[qid]?.options?.[index] || ''}
      onChange={(e) => handleTranslationChange(qid, langId, index, e.target.value)}
      style={{
        width: '100%',
        padding: '6px',
        marginBottom: '6px',
        fontSize: '0.95rem',
        border: '1px solid #ccc',
        borderRadius: '4px',
      }}
    />
     {/* <div style={{ fontSize: '0.75rem', color: '#777', textAlign: 'right' }}>
          {new TextEncoder().encode(translations?.[langId]?.[qid]?.options?.[index]).length} bytes
        </div> */}
       <div
  style={{
    fontSize: '0.75rem',
    textAlign: 'right',
    color: getByteLength(translations?.[langId]?.[qid]?.options?.[index])  > MAX_BUTTON_BYTES ? 'red' : '#777',
  }}
>
  {getByteLength(translations?.[langId]?.[qid]?.options?.[index]) } / {MAX_BUTTON_BYTES} bytes
  {getByteLength(translations?.[langId]?.[qid]?.options?.[index])  > MAX_BUTTON_BYTES && (
    <div style={{ color: 'red', fontSize: '0.7rem' }}>
      Text too long — shorten it
    </div>
  )}
</div>
    </div>
  ))}

  {/* Loader */}
  {translationLoading?.[langId] && (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(255,255,255,0.7)',
        borderRadius: '4px',
        padding: '4px',
        zIndex: 1,
      }}
    >
      <CircularProgress size={24} />
    </div>
  )}
</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default StickyTable;
